import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Input,
  message,
  Select,
  Spin,
  InputNumber,
} from "antd";
import axios from "services/axios";

const FormItem = Form.Item;
const { Option } = Select;

class ConfigurationUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      configuration: {},
      isLoading: false,
      percent: 0,
    };

    this.onChangePercent = this.onChangePercent.bind(this);
  }

  componentDidMount() {
    this.fetchConfigurationDetail(this.props.match.params.id);
  }

  async fetchConfigurationDetail(id) {
    const {
      data: { configuration },
    } = await axios.get(`/configurations/${id}`);
    this.setState({
      configuration,
      percent: parseFloat(parseFloat(configuration.percent).toFixed(2)),
    });
  }

  async updateConfiguration(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      this.setState({ isLoading: true });
      if (!err) {
        let id = this.props.match.params.id;
        axios
          .patch(`/configurations/${id}`, {
            ...values,
            percent: this.state.percent,
          })
          .then((result) => {
            message.success(`Berhasil update Configuration ${values.name}`);
            this.props.history.push(`/home/configurations`);
          })
          .catch((err) => {
            this.errorMessage(err);
          });
      }
      this.setState({ isLoading: false });
    });
  }

  callback(key, props) {
    props.form.resetFields();
  }

  async onChangePercent(val) {
    let percent = parseFloat(parseFloat(val).toFixed(2)) || 0;

    this.setState({ percent });
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Update Configuration");
      }
    } else {
      message.error("Error Update Configuration");
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Card title="Update Configuration">
        <Spin
          tip="Sedang mengupdate Configuration"
          spinning={this.state.isLoading}>
          <Form onSubmit={(e) => this.updateConfiguration(e)}>
            <FormItem label="Name">
              {getFieldDecorator("name", {
                initialValue: this.state.configuration
                  ? this.state.configuration.name
                  : "",
                rules: [
                  { required: true, message: "Configuration wajib diisi" },
                ],
              })(<Input disabled={true} />)}
            </FormItem>
            <InputNumber
              min={0}
              max={100}
              onChange={this.onChangePercent}
              value={this.state.percent}
            />
            <Row type="flex" justify="end">
              <Col>
                <Button htmlType="submit" type="primary">
                  Update
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    );
  }
}

export default Form.create()(ConfigurationUpdate);



// WEBPACK FOOTER //
// src/components/Dashboard/Configuration/ConfigurationUpdate.js